import { background } from './renegades.mjs'
import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/260210/renegades-le_mclaren26-plus--{nnn}.png',
}

export default {
  supports360: false,
  layers: [background, body],
  resolveOptions: () => ({}),
}
